module.exports = __webpack_public_path__ + "img/b75ecc5.svg";